import {Navbar, NavbarBrand } from 'reactstrap';
import React from 'react';
import Image from 'next/image'

export default function Header() {
    return (
        <>
            <div className="menu-container">
                <div className="container">
                    <Navbar color="faded" light expand="lg">
                        <NavbarBrand href="/" className="mr-auto">
                             <Image src="/images/logo-new.png" width="212" height="40" alt="IrsExtensions.Online Logo"/>
                        </NavbarBrand>
                    </Navbar>
                </div>
            </div>
        </>
    )
}


